import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import CustomForm from "../../../components/CustomForm/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../components/Loader/Loader";

const EditEnrollmentSetup = () => {
  const initialFormData = {
    academicYear: "",
    enrollmentBatch: "",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const activeURL = location.pathname.split("/")[4];
  const [formData, setFormData] = useState(initialFormData);
  const [data, setData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchExam = async () => {
      try {
        const response = await adminRequest.post(
          `${BASE_URL}/enrollmentSetup/view`,
          {
            uuid: `${activeURL}`,
          },
        );
        setData(response.data);
        setFormData({
          academicYear: response.data.data.academicYear,
          enrollmentBatch: response.data.data.enrollmentBatch,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchExam();
  }, [activeURL]);

  if (!data || !data.data) {
    return <Loader />;
  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/enrollmentSetup/edit`, {
          uuid: activeURL,
          academicYear: formData.academicYear,
          enrollmentBatch: formData.enrollmentBatch,
        }),
        {
          pending: "Updating Enrollment Setup",
        },
      );

      toast.success(response.data.message, {
        autoClose: 500,
        onClose: () => navigate(-1),
      });

      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fields = [
    {
      name: "academicYear",
      label: "Academic Year",
      type: "text",
      value: formData.academicYear,
      onChange: handleChange,
    },

    {
      name: "enrollmentBatch",
      label: "Enrollment Batch",
      type: "text",
      value: formData.enrollmentBatch,
      onChange: handleChange,
    },
  ];
  return (
    <div className="editEnrollmentContainer">
      <CustomForm
        header="Edit Enrollment Setup"
        fields={fields}
        flexDirection="row"
        createButtonLabel="Update"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      <ToastContainer position="top-center" />
    </div>
  );
};

export default EditEnrollmentSetup;
